import React, { useContext, Fragment } from "react";
import { Helmet } from "react-helmet";
import "../Assets/Css/body.css";
import "../Assets/Css/heading.css";

import Header from "../Components/Header";
//import Footer from "../Components/Footer";
import Offers from "../Components/Offers";
import Facts from "../Components/Facts";
//import StringingClub from "../Components/StringingClub";
import StringingPro from "../Components/StringingPro";
import Icofont from "react-icofont";

import Navigation from "../Components/Navigation";
import Copyrights from "../Components/Copyrights";
import AppContext from "../Components/AppContext";
import OrderForm from "../Components/OrderForm";

import {
	ProStrings,
	ClubStrings,
	WelcomTextProStrings,
	WelcomTextClubStrings,
	WelcomeContactText,
} from "../Components/Texts";

export const Home = (props) => {
	const context = useContext(AppContext);
	props.language === "en" ? context.lang.set("de") : context.lang.set("en");
	return (
		<Fragment>
			<Helmet>
				<html lang={props.language && props.language === "en" ? "en" : "de"} />
			</Helmet>
			<Navigation />
			<Header />
			<Offers />
			<Facts />
			<StringingPro Strings={ProStrings} WelcomeText={WelcomTextProStrings} SectionId="prostrings" />
			<StringingPro Strings={ClubStrings} WelcomeText={WelcomTextClubStrings} SectionId="clubstrings" />
			<OrderForm />
			<section className="page-section bg-primary text-white mb-0" id="contact">
				<div className="container">
					<div className="text-center">
						<h2 className="page-section-heading text-white d-inline-block mb-0">
							{context.lang.get === "en" ? WelcomeContactText[0].title_DE : WelcomeContactText[0].title_ENG}
						</h2>
					</div>

					<div className="divider-custom divider-light mb-3">
						<div className="divider-custom-line"></div>
						<div className="divider-custom-icon">
							<Icofont icon="icofont-ui-call" />
						</div>
						<div className="divider-custom-line"></div>
					</div>

					<div className="row justify-content-center">
						<div className="col-lg-4">
							<div className="d-flex flex-column align-items-center">
								<div className="icon-contact mb-3">
									<i className="fas fa-mobile-alt"></i>
								</div>
								<div className="text-white">Phone</div>
								<div className="lead font-weight-bold">(041) 505 02 41</div>
							</div>
						</div>
						<div className="col-lg-4">
							<div className="d-flex flex-column align-items-center">
								<div className="icon-contact mb-3">
									<Icofont icon="icofont-home" />
								</div>
								<div className="text-white">Addresse</div>
								<div className="lead font-weight-bold text-center">
									CH-6006 <br></br>Luzern
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <Footer /> */}
			<Copyrights />
		</Fragment>
	);
};

export default Home;
